import React from 'react';
import { desktopscreensize } from '../../../../../utilities/constants';
import { NavBarButtonLinks } from '../NavBarButtonLinks';
import { NavBarTypes } from '../navBarTypes';

export const getCTAButtonColorClass = (index: number, widthwindow: number) => {
  if (index === 1 || (index === 0 && widthwindow < desktopscreensize)) {
    return 'cp-primary-button-highlighted';
  }
  return 'cp-outlined-button-highlighted';
};

export const getButtonStyle = (index: number, widthwindow: number) => {
  return `buttonDisplay${index +
    1}FirstVariant has-background-highlight-light ${getCTAButtonColorClass(
    index,
    widthwindow
  )}`;
};

export const getClassNameForButtonsNavBar = (
  index: number,
  widthwindow: number
) => {
  if (index === 0) {
    return getButtonStyle(index, widthwindow);
  } else {
    return `buttonDisplay${index + 1} ${getCTAButtonColorClass(
      index,
      widthwindow
    )}`;
  }
};

export const selectClassName = (index: number, width: number) => {
  return getClassNameForButtonsNavBar(index, width);
};
export const GenericButtonLinks = ({
  handleNavBarStateButton,
  width,
  button,
  index,
}: NavBarTypes.TGenericButtonLinks) => {
  return (
    <NavBarButtonLinks
      handleNavBarStateButton={handleNavBarStateButton}
      width={width}
      buttonConfig={button}
      index={index}
    />
  );
};
